import styled from 'styled-components'

export const Label = styled.span<{ isLabelBold?: boolean; hasPadding?: boolean }>`
  display: block;
  font-weight: ${(props) =>
    props.isLabelBold ? props.theme.font.weights.semiBold : props.theme.font.weights.regular};
  text-align: left;
  padding-top: ${({ hasPadding, theme: { mp } }) => hasPadding && mp.sm};
  padding-bottom: ${({ hasPadding, theme: { mp } }) => hasPadding && mp.sm};
`

export const TooltipWrapper = styled.div`
  padding-left: ${(props) => props.theme.mp.xs};
  display: inline-block;
`

export const LabelTooltipWrapper = styled.div<{ isVerticallyCentered: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: ${({ isVerticallyCentered }) => (isVerticallyCentered ? 'center' : 'initial')};
  justify-content: flex-start;
  height: 100%;
`
